import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { createListForSingleOption } from "components/allForm/createableSelect";
import { fetchAsyncGetFormOptions } from "redux/formOptions";
import useFormOptionsApi from "./useFormOptionApi";

const useFormOptions = (expenseType) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const formOptionsList1 = useSelector((state) => state.formOptions);
  const [formOptionsList, setFormOptionsList] = useState([]);
  const [payeeOption, setPayeeOption] = useState([]);
  const [bankOption, setBankOption] = useState([]);
  const [receiverOption, setReceiverOption] = useState([]);
  const [expenseOption, setExpenseOption] = useState([]);
  const [agencyOption, setAgencyOption] = useState([]);
  const [currencyOption, setCurrencyOption] = useState([]);

  const {
    createFormOptionApi,
    deleteFormOptionApi,
    editFormOptionApi,
  } = useFormOptionsApi();

  useEffect(() => {
    const fetchFormOptions = async () => {
      await dispatch(fetchAsyncGetFormOptions());
    };
    fetchFormOptions();
  }, [dispatch]);

  useEffect(() => {
    if (formOptionsList1 && formOptionsList1.length > 0) {
      const filteredOptions = formOptionsList1.filter(item => item.expTyp === expenseType);
      setFormOptionsList(filteredOptions);

      setReceiverOption(createListForSingleOption(filteredOptions, "receiver"));
      setAgencyOption(createListForSingleOption(filteredOptions, "agency"));
      setExpenseOption(createListForSingleOption(filteredOptions, "expense"));
      setCurrencyOption(createListForSingleOption(filteredOptions, "currency"));
      setPayeeOption(createListForSingleOption(filteredOptions, "payee"));
      setBankOption(createListForSingleOption(filteredOptions, "bank"));

    }
  }, [formOptionsList1, expenseType]);

  const createNewFormOption = async (data, type) => {
    createFormOptionApi(data, type, expenseType);
    dispatch(fetchAsyncGetFormOptions());

  };

  const deleteFormOption = async (option, type) => {
    const result = await deleteFormOptionApi(option.id);
    dispatch(fetchAsyncGetFormOptions());

    addToast(result.message, { appearance: result.success ? 'success' : 'error' });
  };

  const editFormOption = async (option, newValue, type) => {
    const result = await editFormOptionApi(option.id, newValue, expenseType);
    if (result.success) {
      addToast('Option edited successfully!', { appearance: 'success' });
      if (result.data) {
        dispatch(fetchAsyncGetFormOptions());
      }
    } else {
      addToast(result.message, { appearance: 'error' });
    }
  };

  return {
    formOptionsList,
    payeeOption,
    bankOption,
    receiverOption,
    expenseOption,
    agencyOption,
    currencyOption,
    createNewFormOption,
    deleteFormOption,
    editFormOption

  };
};

export default useFormOptions;
